// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import isEmpty from 'lodash/isEmpty';
import Image from '../../Image';
import { Container, DynamicContent } from '../styles/CategoryContent.style';

const CategoryContent = ({
  tableData,
  categoryData,
  isQuickView,
  isSizeTableLoaded,
  isContentPage,
  seoDescriptionValue,
}) => {
  if (!isSizeTableLoaded) {
    return <></>;
  }
  const isHtmlContain =
    !isEmpty(tableData) &&
    !isEmpty(tableData?.htmlContent) &&
    tableData?.htmlContent?.trim() !== '';

  return (
    <Container className="size-chart-outer-block">
      {isHtmlContain ? (
        <DynamicContent
          className="dynamic-html-content"
          dangerouslySetInnerHTML={{ __html: tableData.htmlContent }}
        />
      ) : (
        <></>
      )}
      <Image categoryData={categoryData} isQuickView={isQuickView} />
      {isContentPage && !isEmpty(seoDescriptionValue) ? (
        <DynamicContent
          className="dynamic-html-content"
          dangerouslySetInnerHTML={{ __html: seoDescriptionValue }}
        />
      ) : (
        <></>
      )}
    </Container>
  );
};

export default CategoryContent;
